import Controller from '@ember/controller';
import { inject } from '@ember/service';
import { IntlService } from 'ember-intl';
import { RegisterUserModel } from 'login/routes/register-user';

export default class RegisterUserController extends Controller<RegisterUserModel> {
  @inject intl!: IntlService;

  get languageCandidates(): { value: string; label: string }[] {
    return this.model.languageCandidates.map((candidate) => {
      const code = candidate.trim();
      return {
        value: code,
        label: this.intl.t(`language.${code}`),
      };
    });
  }

  get unitCandidates(): { value: string; label: string }[] {
    return this.model.unitCandidates.map((candidate) => {
      const code = candidate.trim();
      return {
        value: code,
        label: this.intl.t(`unit.${code}`),
      };
    });
  }
}
